import React from 'react';
import ClientDashboard from './ClientDashboard';

function PendingProjects() {
  return <ClientDashboard defaultTab="pending" />;
}

export default PendingProjects;